import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { useRef } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { toast } from 'react-toastify'
// 👇 import correctly (default import)
import trimCanvas from 'trim-canvas'

interface PdfFormProps {
  setImageURL: (url: string) => void
  isOpen: boolean
  closeSignaturePad: () => void
  title: string
}

const SignaturePad = ({
  isOpen,
  setImageURL,
  closeSignaturePad,
  title,
}: PdfFormProps) => {
  const sigCanvas = useRef<SignatureCanvas>(null)

  // Save signature
  const saveSignature = () => {
    if (sigCanvas.current) {
      try {
        // Trim manually with trim-canvas
        const canvas = sigCanvas.current.getCanvas()
        const trimmed = trimCanvas(canvas) // ✅ works now
        const url = trimmed.toDataURL('image/png')
        setImageURL(url)
      } catch (error) {
        toast.error(
          error instanceof Error ? error.message : 'Something went wrong'
        )
        // fallback: use the raw canvas
        const url = sigCanvas.current.toDataURL('image/png')
        setImageURL(url)
      }
      closeSignaturePad()
    }
  }

  // Clear signature
  const clearSignature = () => {
    sigCanvas.current?.clear()
    setImageURL('')
  }

  return (
    <Dialog open={isOpen} onOpenChange={closeSignaturePad}>
      <DialogContent
        className='rounded-xl p-5 py-9 md:p-9 bg-white shadow-lg  overflow-y-auto hide-scroll
  [&_>button]:w-6 [&_>button]:h-6 [&_>button]:top-1 sm:[&_>button]:top-2 [&_>button]:right-1 sm:[&_>button]:right-2 [&_>button]:flex [&_>button]:justify-center [&_>button]:items-center'
      >
        <DialogTitle className='pb-4 text-black font-semibold text-lg md:text-2xl w-full'>
          {title}
        </DialogTitle>
        <div className='flex flex-col items-center space-y-4'>
          <SignatureCanvas
            ref={sigCanvas}
            penColor='black'
            canvasProps={{
              className: 'border rounded-xl w-full aspect-video',
            }}
          />

          <div className='flex space-x-4'>
            <button
              onClick={saveSignature}
              className='px-4 py-2 bg-green-600 text-white rounded'
            >
              Save
            </button>
            <button
              onClick={clearSignature}
              className='px-4 py-2 bg-red-600 text-white rounded'
            >
              Clear
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default SignaturePad
